exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-message {\n  background-color: #F2F3F3;\n  border: 1px solid #E0E1E2;\n  border-radius: 8px;\n  color: #4C4D4F;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 12px;\n}\n", ""]);

// exports
